import React from 'react';
import { NavLink } from 'react-router-dom';
import './styles/LoginSection.css'; // Ensure the CSS file is inside the src/styles directory

const LoginSection = () => {
  return (
    <div className="login-section-container">
      <h2 className="text-center">Welcome to the Placement Training System</h2>
      <p className="text-center great-quote">"The future belongs to those who believe in the beauty of their dreams." - Eleanor Roosevelt</p>
      <div className="login-options-row">
        <NavLink to="/facultylogin" className="login-option">
          Faculty Login
        </NavLink>
        <NavLink to="/trainer-login" className="login-option">
          Trainer Login
        </NavLink>
        <NavLink to="/student-login" className="login-option">
          Student Login
        </NavLink>
      </div>
    </div>
  );
};

export default LoginSection;
